// src/components/CustomWorkoutButton.js
import React, { useState, useContext } from "react";
import "./style.css";
import LanguageContext from "../../context/LanguageContext";

// Import data
const jsonDataEn = require("../data/contact-data-en.json");
const jsonDataFr = require("../data/contact-data-fr.json");

const CustomWorkoutButton = ({ recipient }) => {
  const { language } = useContext(LanguageContext);
  const data = language === "en" ? jsonDataEn.data.customWorkout : jsonDataFr.data.customWorkout;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    setSubmitted(false); // reset on open
    setEmail("");
  };
  const closeModal = () => setIsModalOpen(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const API_BASE = process.env.REACT_APP_API_BASE_URL;
      await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, recipient }),
      });
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      alert(data.fail);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <button className="contact-button-sm" onClick={openModal}>
        {data.button}
      </button>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
            {!submitted ? (
              <>
                <h2 className="modal-title">{data.title}</h2>
                <p className="modal-description">{data.description}</p>

                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="email">
                      {data.email}: <span className="required-asterisk">*</span>
                    </label>
                    <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  </div>
                  <button type="submit" className="modal-submit-btn" disabled={isSubmitting}>
                    {isSubmitting ? data.submitting : data.submit}
                  </button>
                </form>
              </>
            ) : (
              <div className="thank-you-message">
                <h3>{data.successTitle}</h3>
                <p>{data.successDescription}</p>
                <button className="modal-submit-btn" onClick={closeModal}>
                  {data.close}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CustomWorkoutButton;
